/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import IAlarm = Models.IAlarm;

    export interface IAcknowledgeModalScope extends ng.IScope {
        modalClose: () => void;
        modalSave: () => void;
        alarm: IAlarm;
        comment: string;
        editMode: boolean;

        getSeverityColor: (severity: number) => string;
        getSeverityText: (severity: number) => string;
        getType: (href: string) => string;
        timezoneService: Services.TimezoneService;
    }

    /**
     * AcknowledgeModalController class
     */
    export class AcknowledgeModalController {
        public static templateURL: string = "decorators/modals/acknowledge-modal.html";
        public static ID: string = "#id-acknowledge-modal";
        public static $name: string = "acknowledgeModalController";
        public static $inject: string[] = ['$scope',
                                           'alarmsService',
                                           'timezoneService',
                                           'close',
                                           '$timeout',
                                           'selectedAlarm',
                                           'comment',
                                           'editMode',
                                           '$timeout'];

        private $scope: IAcknowledgeModalScope;
        private close: (parameters: ngModal.ICloseParameters) => void;

        /**
         * Constructor
         */
        constructor($scope: IAcknowledgeModalScope,
                    alarmsService: Services.AlarmsService,
                    timezoneService: Services.TimezoneService,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    $timeout: ng.ITimeoutService,
                    selectedAlarm: IAlarm,
                    comment: string,
                    editMode: boolean) {
            $timeout(() => {
                window.altair_admin_common_init();
            }, 500);

            this.close = close;
            this.$scope = $scope;
            this.$scope.alarm = selectedAlarm;
            this.$scope.comment = comment;
            this.$scope.editMode = editMode;
            this.$scope.timezoneService = timezoneService;

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = (): void => {
                this.close(this.$scope.comment);
            };

            this.$scope.getSeverityColor = (severity: number): string => {
                return alarmsService.getSeverityColor(severity);
            };

            this.$scope.getSeverityText = (severity: number): string => {
                return alarmsService.getSeverityText(severity);
            };

            this.$scope.getType = (href: string) => {
                return Models.Alarm.getType(href);
            };
        }
    }
}
